<template>
  <div class="line-decoupe">
    <!-- Nom du produit + suppression -->
    <div class="row">
      <div class="col s10">
        <h2>{{product.name}}</h2>
      </div>
      <div class="col s2 right-align">
        <i class="material-icons close-icon" @click="remove">close</i>
      </div>
    </div>

    <!-- Quantité et longueur -->
    <div class="row">
      <div class="col s6">
        <select-number v-bind:propQuantity="product.quantity" v-on:change="editQuantity"
        id="quantity" label="Quantité pièce"></select-number>
      </div>
      <div class="col s6">
        <select-number v-bind:propQuantity="product.length" v-on:change="editLength"
        id="length" label="Longueur (ML)"></select-number>
      </div>
    </div>

    <!-- Largeur et prix -->
    <div class="row">
      <div v-if="product.coefficient !== 1" class="col s6">
        <info id="width" label="Largeur (ML)" :value="product.coefficient"></info>
      </div>
      <div class="col s6">
        <info id="price" label="Prix" :value="(product.price * product.coefficient).toFixed(2)+'€'"></info>
      </div>
    </div>

    <!-- "TOTAL" + si m², surface total + total -->
    <div class="row">
      <div v-bind:class="[product.coefficient !== 1 ? 's4' : 's6', 'col']">
        <info value="TOTAL"></info>
      </div>
      <div
        v-if="product.coefficient !== 1"
        v-bind:class="[product.coefficient !== 1 ? 's4' : 's6', 'col']"
      >
        <info :value="(product.coefficient * product.quantity * product.length).toFixed(2)+'M²'"></info>
      </div>
      <div v-bind:class="[product.coefficient !== 1 ? 's4' : 's6', 'col']">
        <info :value="(product.price * product.coefficient * product.quantity * product.length).toFixed(2)+'€'"></info>
      </div>
    </div>
  </div>
</template>

<script>
import Info from "@/components/Product/Info.vue";
import SelectNumber from "@/components/SelectNumber.vue";

export default {
  props: ["product"],
  methods: {
    editQuantity: function(quantity) {
      this.$store.commit("editQuantity", {id:this.product.id, quantity:quantity});
    },
    editLength: function(length) {
      this.$store.commit("editLength", {id:this.product.id, length:length});
    },
    remove: function() {
      this.$store.commit("removeProduct", this.product.id);
    }
  },
  components: {
    Info,
    SelectNumber
  }
};
</script>

<style scoped>
h2 {
  font-size: 1.3em;
  margin: 0;
}
.line-decoupe {
  padding: 1em 1em 0 1em;
  background-color: #eeeeee;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  margin-bottom: 1.5em;
}

.close-icon {
  border: 2px solid rgb(104, 104, 104);
  border-radius: 50%;
}

label {
  display: block;
  text-align: center;
}

.number-button {
  float: left;
  display: block;
  width: 100%;
  height: 35px;
  text-align: center;
  font-size: 100%;
  border: 2px black solid;
  padding: 0.2em;
  line-height: 25px;
}
</style>